
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

export default {
components: {
Checker,
CheckerItem
},
name: 'maternal_form_a_detail',
data(){
return{
get_host:host.host,
type:'',
showSignature:false,
showUserSignature:false,
form:{
room_number:'',
entry_time:'',
name:'',
age:'',
blood_type:'',
national:'',
native_place:'',
maternity_hospital:'',
maternity_date:'',
maternity_type:'',
leave_hos_smary:'',
medication_history:'',
allergy_history:'',
leave_hos_diagnosis:'',
pregnancy_illness:'',
maternity_special_case:'',
acute_disease_treat:'',
contagion_stage:'',
spirit_history:'',
heart_assess:'',
have_heart_case:'',
have_heart_desc:'',
character_type:'',
emotion:'',
appetite:'',
diet_require:'',
diet_require_other:'',
diet_hobby_status:'',
has_diet_hobby_desc:'',
allergy_food:'',
micturition_case:'',
micturition_num:'',
urination_pain:'',
defecation_case:'',
defecation_num:'',
do_recovery_know:'',
attend_pregnancy_edu:'',
family_do_maternal_att:'',
family_other_desc:'',
temperature:'',
blood_pressure:'',
pulse_num:'',
breathing_num:'',
weight:'',
complexion:'',
mouth_mucosa:'',
activity:'',
lochia_colour:'',
lochia_amount:'',
lochia_sniff:'',
lochia_gdg:'',
incision_case:'',
incision_case_desc:'',
breast_case:'',
papilla_case:'',
milk_case:'',
milk_other_case:'',
special_find:'',
maternal_nursing_check:'',
maternal_nursing_want:'',
autograph:'',
customer_sign:'',
assess_time:''
},
option:{
penColor:"rgb(0, 0, 0)"
},
}
},
methods:{

save(){
let signature ='signature1'
const sigRef = this.$refs[signature]
const comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef
if (!comp || !comp.save) return
let png = comp.save()
this.form.autograph = encodeURI(png)
this.showSignature = true
},

edit(){
this.showSignature = false
},

clear(){
let signature ='signature1'
const sigRef = this.$refs[signature]
if (Array.isArray(sigRef)) {
sigRef.forEach(c => c && c.clear && c.clear())
} else if (sigRef && sigRef.clear) {
sigRef.clear()
}
this.form.autograph = ''
},

saveUserName(){
let signature ='signature2'
const sigRef = this.$refs[signature]
const comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef
if (!comp || !comp.save) return
let png = comp.save()
this.form.customer_sign = encodeURI(png)
this.showUserSignature = true
},

editUserName(){
this.showUserSignature = false
this.form.customer_sign = ''
},

clearUserName(){
let signature ='signature2'
const sigRef = this.$refs[signature]
if (Array.isArray(sigRef)) {
sigRef.forEach(c => c && c.clear && c.clear())
} else if (sigRef && sigRef.clear) {
sigRef.clear()
}
this.form.customer_sign = ''
},
submitForm(){
this.$router.replace({
path:'/maternal_form_a_edit',
query:{
id:this.$route.query.id,
form_id:this.$route.query.form_id,
tabVal: this.$route.query.tabVal
}
})
},
goBack(){
this.$router.push({
path: './maternal_service',
query: {
tabVal: this.$route.query.tabVal,
id: this.$route.query.id
}
})
}
},
created(){
let params ={
token:this.$cookie.get('token'),
id:this.$route.query.form_id
}
this.$vux.loading.show({
text: '正在加载'
})
console.info(params)
Api.otherFormApi.getMaterCheckAssessFind(params).then (res => {
this.$vux.loading.hide()
console.info("详情",res.data)
if(res.errcode==200){
let data =res.data
this.form.room_number=data.room_number,
this.form.entry_time=data.entry_time,
this.form.name=data.name,
this.form.age=data.age,
this.form.blood_type=data.blood_type,
this.form.national=data.national,
this.form.native_place=data.native_place,
this.form.maternity_hospital=data.maternity_hospital,
this.form.maternity_date=data.maternity_date,
this.form.maternity_type=data.maternity_type=='1'?'经阴道':data.maternity_type=='2'?'剖宫产':data.maternity_type=='3'?'小产':'',
this.form.leave_hos_smary=data.leave_hos_smary == '1' ? '有' : data.leave_hos_smary == '2' ? '无' : '',
this.form.medication_history=data.medication_history,
this.form.allergy_history=data.allergy_history,
this.form.leave_hos_diagnosis=data.leave_hos_diagnosis,
this.form.pregnancy_illness=data.pregnancy_illness,
this.form.maternity_special_case=data.maternity_special_case,
this.form.acute_disease_treat=data.acute_disease_treat == "2" ? '否':(data.acute_disease_treat == "1" ? '是' : ''),
this.form.contagion_stage=data.contagion_stage == "2" ? '否':(data.contagion_stage == "1" ? '是' : ''),
this.form.spirit_history=data.spirit_history == "2" ? '无':(data.spirit_history == "1" ? '有' : ''),
this.form.heart_assess=data.heart_assess == "2" ? '无':(data.heart_assess == "1" ? '有' : (data.heart_assess == "3" ? '正常' : '')),
this.form.have_heart_desc=data.have_heart_desc,
this.form.have_heart_case=data.have_heart_case=="1"?'正常':''
this.form.character_type=data.character_type == "1" ? '主动外向':(data.character_type == "2" ? '被动内向' : ''),
this.form.emotion=data.emotion == "1" ? '稳定':(data.emotion == "2" ? '兴奋' : (data.emotion == "3" ? '郁闷' : (data.emotion == "4" ? '焦虑' : (data.emotion == "5" ? '恐惧' : '')))),
this.form.appetite=data.appetite== "1" ? '正常':(data.appetite == "2" ? '不佳' : ''),
this.form.diet_require=data.diet_require== "1" ? '普食':(data.diet_require == "2" ? '其他' : ''),
this.form.diet_require_other=data.diet_require_other,
this.form.diet_hobby_status=data.diet_hobby_status == "1" ? '有':(data.diet_hobby_status == "2" ? '无' : ''),
this.form.has_diet_hobby_desc=data.has_diet_hobby_desc,
this.form.allergy_food=data.allergy_food,
this.form.micturition_case=data.micturition_case== "1" ? '正常':(data.micturition_case == "2" ? '尿频' : ''),
this.form.micturition_num=data.micturition_num
this.form.urination_pain=data.urination_pain == "1" ? '有':(data.urination_pain == "2" ? '无' : ''),
this.form.defecation_case=data.defecation_case== "1" ? '正常':(data.defecation_case == "2" ? '便秘' : (data.defecation_case == "3" ? '腹泻' : (data.defecation_case == "4" ? '未排' : ''))),
this.form.defecation_num=data.defecation_num,
this.form.do_recovery_know=data.do_recovery_know== "1" ? '熟悉':(data.do_recovery_know == "2" ? '了解' : (data.do_recovery_know == "3" ? '不了解' : '')),
this.form.attend_pregnancy_edu=data.attend_pregnancy_edu== "1" ? '共同':(data.attend_pregnancy_edu == "2" ? '本人' : (data.attend_pregnancy_edu == "3" ? '家属' : '')),
this.form.family_do_maternal_att=data.family_do_maternal_att== "1" ? '恰当的关心':(data.family_do_maternal_att == "2" ? '不关心' : (data.family_do_maternal_att == "3" ? '过于关心' : (data.family_do_maternal_att == "4" ? '其他' : ''))),
this.form.family_other_desc=data.family_other_desc,
this.form.temperature=data.temperature,
this.form.blood_pressure=data.blood_pressure,
this.form.pulse_num=data.pulse_num,
this.form.breathing_num=data.breathing_num,
this.form.weight=data.weight,
this.form.complexion=data.complexion== "1" ? '红润':(data.complexion == "2" ? '苍白' : (data.complexion == "3" ? '黄染' : '')),
this.form.mouth_mucosa=data.mouth_mucosa== "1" ? '完整':(data.mouth_mucosa == "2" ? '溃疡' : ''),
this.form.activity=data.activity== "1" ? '良好':(data.activity == "2" ? '受限' : ''),
this.form.lochia_colour=data.lochia_colour,
this.form.lochia_amount=data.lochia_amount,
this.form.lochia_sniff=data.lochia_sniff,
this.form.lochia_gdg=data.lochia_gdg,
this.form.incision_case=data.incision_case== "1" ? '腹壁':(data.incision_case == "2" ? '会阴侧切' : (data.incision_case == "3" ? '会阴正中' : data.incision_case == "4" ? '无切口' : '')),
this.form.incision_case_desc=data.incision_case_desc== "1" ? '红':(data.incision_case_desc == "2" ? '肿' : (data.incision_case_desc == "3" ? '痛' : (data.incision_case_desc == "4" ? '渗出' : (data.incision_case_desc == "5" ? '无异常' : '')))),
this.form.breast_case=data.breast_case== "1" ? '正常':(data.breast_case == "2" ? '饱胀' : (data.breast_case == "3" ? '平坦' : (data.breast_case == "4" ? '肿胀' : (data.breast_case == "5" ? '副乳' : '')))),
this.form.papilla_case=data.papilla_case == "1" ? '正常':(data.papilla_case == "2" ? '内陷' : (data.papilla_case == "3" ? '皲裂' : (data.papilla_case == "4" ? '水泡' : ''))),
this.form.milk_case=data.milk_case== "1" ? '多':(data.milk_case == "2" ? '中' : (data.milk_case == "3" ? '少' : (data.milk_case == "4" ? '无' : ''))),
this.form.milk_other_case=data.milk_other_case,
this.form.special_find=data.special_find,
this.form.maternal_nursing_want=data.maternal_nursing_want,
this.form.autograph=data.autograph.indexOf(this.get_host) != -1 ? data.autograph : this.get_host+data.autograph
this.form.customer_sign=data.customer_sign.indexOf(this.get_host) != -1 ? data.customer_sign : this.get_host+data.customer_sign
this.form.assess_time=data.assess_time
let Arr=res.data.maternal_nursing_check
for(let i=0;i<Arr.length;i++){
if(Arr[i]=='1'){
Arr[i]='观察恶露量，颜色和气味'
}else if(Arr[i]=='2'){
Arr[i]='保证室内有新鲜空气，保持充足的睡眠'
}else if(Arr[i]=='3'){
Arr[i]='产妇要保持心情愉悦'
}else if(Arr[i]=='4'){
Arr[i]='剖宫产产妇要检查子宫缝合的伤口愈合情况'
}else if(Arr[i]=='5'){
Arr[i]='顺产产妇要观察宫缩情况并注意会阴部伤口的清洁'
}else if(Arr[i]=='6'){
Arr[i]='让婴儿早吸吮，保持乳房清洁'
}
this.form.maternal_nursing_check=Arr.join()
}
}
})
}
}



// WEBPACK FOOTER //
// ./src/components/maternal_form_a_detail.vue